import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

/**
 * Small uppercase label that introduces a group of cards or a sub-section
 * inside a page (e.g. "Calling Cards", "Activity & Inventory"). Themed —
 * uses `theme.textMute` so it sits quietly above the content it labels.
 *
 *   <NtSectionLabel>Calling Cards</NtSectionLabel>
 */
function NtSectionLabel({ children, style }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return <NtText style={[styles.label, style]}>{children}</NtText>;
}

const makeStyles = (t) =>
  StyleSheet.create({
    label: {
      fontSize: 11,
      fontWeight: "600",
      color: t.textMute,
      letterSpacing: 1.2,
      textTransform: "uppercase",
      marginTop: 24,
      marginBottom: 8,
    },
  });

export default NtSectionLabel;
